import * as types from '../actions/actionTypes';

const initialState = {
    payload: {

        countries: [],
        countryFinInfo:[],
        countryFullInfo:[],
        highlights: {},
        comparison: null,
        forecast: {},
        forecastAccuracy: {},
        syncStatus: null,
        regions: [],
        macroPulse: null
    },
    loading: false,
    error: null,
    success: null
}

const countries = (state = initialState, action) => {    
    switch (action.type) {
        case types.GET_COUNTRIES_REQUEST:
            return { ...state, loading: true, success: false };
        case types.GET_COUNTRIES_SUCCESS:
            return { ...state, loading: false, success: true, payload: {...state.payload, countries: action.payload } };
        case types.GET_COUNTRIES_FAILURE:
            return { ...state, loading: false, success: false, error: action.error };
        case types.GET_REGIONS_REQUEST:
            return { ...state, loading: true, success: false };
        case types.GET_REGIONS_SUCCESS:
            return { ...state, loading: false, success: true, payload: { ...state.payload, regions: action.payload } };
        case types.GET_REGIONS_FAILURE:
            return { ...state, loading: false, success: false, error: action.error };
        case types.GET_COUNTRY_FIN_INFO_REQUEST:
        case types.GET_COUNTRY_FULL_INFO_REQUEST:
            return { ...state, loading: true, success: false };
        case types.GET_COUNTRY_FIN_INFO_SUCCESS: { 
            let org = Array.from(state.payload.countryFinInfo);            
            const index =  org.indexOf(x => x.countryCode === action.payload.countryCode);
            if (index > 0) {
                org[index] = action.payload;
            }
            else {
                org.push(action.payload);
            }
            return { ...state, loading: false, success: true, payload: { ...state.payload, countryFinInfo: org } };
        }
        case types.GET_COUNTRY_FULL_INFO_SUCCESS: {             
            let org = Array.from(state.payload.countryFullInfo);            
            const index =  org.indexOf(x => x.countryCode === action.payload.countryCode);
            if (index > 0) {
                org[index] = action.payload;
            }
            else {
                org.push(action.payload);
            }
            return { ...state, loading: false, success: true, payload: { ...state.payload, countryFullInfo: org } };
        }
        case types.GET_COUNTRY_FIN_INFO_FAILURE:
        case types.GET_COUNTRY_FULL_INFO_FAILURE:
            return { ...state, loading: false, success: false, error: action.error };
        case types.GET_COUNTRY_HIGHLIGHTS_REQUEST:
        case types.GET_COUNTRY_COMPARISON_REQUEST:
        case types.GET_COUNTRY_FORECAST_REQUEST:
        case types.GET_FORECAST_ACCURACY_REQUEST:
        case types.GET_DATA_SYNC_STATUS_REQUEST:
            return { ...state, loading: true, success: false };
        case types.GET_COUNTRY_HIGHLIGHTS_SUCCESS: {
            const highlights = { ...state.payload.highlights, [action.payload.countryCode]: action.payload.highlights };
            return { ...state, loading: false, success: true, payload: { ...state.payload, highlights } };
        }
        case types.GET_COUNTRY_COMPARISON_SUCCESS:
            return { ...state, loading: false, success: true, payload: { ...state.payload, comparison: action.payload } };
        case types.GET_COUNTRY_FORECAST_SUCCESS: {
            const forecast = { ...state.payload.forecast, [action.payload.countryCode]: action.payload.forecast };
            return { ...state, loading: false, success: true, payload: { ...state.payload, forecast } };
        }
        case types.GET_FORECAST_ACCURACY_SUCCESS: {
            const forecastAccuracy = { ...state.payload.forecastAccuracy, [action.payload.countryCode]: action.payload.runs };
            return { ...state, loading: false, success: true, payload: { ...state.payload, forecastAccuracy } };
        }
        case types.GET_DATA_SYNC_STATUS_SUCCESS:
            return { ...state, loading: false, success: true, payload: { ...state.payload, syncStatus: action.payload } };
        case types.GET_MACRO_PULSE_REQUEST:
            return { ...state, loading: true, success: false };
        case types.GET_MACRO_PULSE_SUCCESS:
            return { ...state, loading: false, success: true, payload: { ...state.payload, macroPulse: action.payload } };
        case types.GET_MACRO_PULSE_FAILURE:
            return { ...state, loading: false, success: false, error: action.error };
                case types.GET_MACRO_CALENDAR_REQUEST:
                    return { ...state, loading: true, success: false };
                case types.GET_MACRO_CALENDAR_SUCCESS:
                    return { ...state, loading: false, success: true, payload: { ...state.payload, macroCalendar: action.payload } };
                case types.GET_MACRO_CALENDAR_FAILURE:
                    return { ...state, loading: false, success: false, error: action.error };
                case types.GET_MACRO_BRIEFING_REQUEST:
                    return { ...state, loading: true, success: false };
                case types.GET_MACRO_BRIEFING_SUCCESS:
                    return { ...state, loading: false, success: true, payload: { ...state.payload, macroBriefing: action.payload } };
                case types.GET_MACRO_BRIEFING_FAILURE:
                    return { ...state, loading: false, success: false, error: action.error };
                                case types.GET_HISTORICAL_GDP_REQUEST:
                                    return { ...state, loading: true, success: false };
                                case types.GET_HISTORICAL_GDP_SUCCESS:
                                    return { ...state, loading: false, success: true, payload: { ...state.payload, historicalGdp: action.payload } };
                                case types.GET_HISTORICAL_GDP_FAILURE:
                                    return { ...state, loading: false, success: false, error: action.error };
                                case types.GET_HISTORICAL_INFLATION_REQUEST:
                                    return { ...state, loading: true, success: false };
                                case types.GET_HISTORICAL_INFLATION_SUCCESS:
                                    return { ...state, loading: false, success: true, payload: { ...state.payload, historicalInflation: action.payload } };
                                case types.GET_HISTORICAL_INFLATION_FAILURE:
                                    return { ...state, loading: false, success: false, error: action.error };
                                case types.GET_STUDIO_INDICATORS_REQUEST:
                                    return { ...state, loading: true, success: false };
                                case types.GET_STUDIO_INDICATORS_SUCCESS:
                                    return { ...state, loading: false, success: true, payload: { ...state.payload, studioIndicators: action.payload } };
                                case types.GET_STUDIO_INDICATORS_FAILURE:
                                    return { ...state, loading: false, success: false, error: action.error };
                                case types.GET_COUNTRY_HIGHLIGHTS_FAILURE:
        case types.GET_COUNTRY_COMPARISON_FAILURE:
        case types.GET_COUNTRY_FORECAST_FAILURE:
        case types.GET_FORECAST_ACCURACY_FAILURE:
        case types.GET_DATA_SYNC_STATUS_FAILURE:
            return { ...state, loading: false, success: false, error: action.error };
        default:
            return { ...state, loading: false, error: null, success: false };
    }
}

export default countries;